import React from 'react'
import { TrendingUp } from 'lucide-react'
import { PlaceholderPage } from '@/components/PlaceholderPage'

export const AccountingRevenuePage: React.FC = () => (
  <PlaceholderPage
    icon={TrendingUp}
    titleKey="business.accountingRevenueTitle"
    descriptionKey="business.accountingRevenueDescription"
  />
)
